export const formatProductUrl = (url: string, fragments?: object): string => {
  if (!url) return "";
  const [baseUrl, existingFragment] = url.split("#");

  const match = baseUrl?.match(/\/([^/]+)\/prd\/(\d+)/) ?? null;
  if (!match) return "";

  const [, productName, productId] = match;

  let formattedUrl = `/product/${productName}/${productId}`;

  if (fragments) {
    formattedUrl +=
      "#" +
      Object.entries(fragments)
        .map(([key, value]) => `${key}-${value}`)
        .join("&");
  }

  if (existingFragment) {
    formattedUrl += `${fragments ? "&" : "#"}${existingFragment}`;
  }

  return formattedUrl;
};

export const removeBaseDomainFromUrl = (url: string): string => {
  if (!url) return "";
  return url.replace(
    /^https:\/\/[a-zA-Z]{1,}\.[a-zA-Z]{1,}\.com\/[a-zA-Z]{1,}/,
    "",
  );
};

export const formatCategoryPillUrl = (url: string): string => {
  if (!url) return "";

  // Create URL object to handle parsing
  try {
    const urlObject = new URL(url);
    const pathSegments = urlObject.pathname.split("/").filter(Boolean);

    // Look for topman/topshop in the path
    const brandIndex = pathSegments.findIndex((segment) =>
      ["topman", "topshop"].includes(segment.toLowerCase()),
    );

    if (brandIndex === -1) return "";

    const brand = pathSegments[brandIndex];

    // Find the index of 'cat' to get the category path
    const catIndex = pathSegments.indexOf("cat");
    if (catIndex === -1) return "";

    // Get all segments between brand and 'cat' to form the category path
    // Filter out 'cat' and 'category' to handle both old and new API response formats:
    // Old format: /gb/topshop/ctas/topshop-edit-5/cat/?cid=52991
    // New format: /gb/topshop/category/ctas/topshop-edit-5/cat/?cid=52991
    const categoryPath = pathSegments
      .slice(brandIndex + 1, catIndex)
      .filter((segment) => segment !== "cat" && segment !== "category")
      .join("/");

    // Construct the new URL
    let formattedUrl = `/${brand}/category/${categoryPath}`;

    // Add query parameters if they exist
    if (urlObject.search) {
      formattedUrl += urlObject.search;
    }

    // Add hash if it exists
    if (urlObject.hash) {
      formattedUrl += urlObject.hash;
    }

    return formattedUrl;
  } catch (error) {
    console.error("Error formatting category pill URL:", error);
    return url;
  }
};
